module.exports = __webpack_public_path__ + "app-static/img/dsx.18d90d79.png";